import { useAuth } from 'nursd-dashboard/context/AuthContext';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import JobTable from './JobTable';
import { getAllTimeCardLocation } from 'nursd-dashboard/api/timeSheet';

function JobIndex() {
  const { authToken, location, organization } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getFacilityJob();
  }, []);

  const getFacilityJob = async () => {
    try {
      const itemArr = await getAllTimeCardLocation(
        authToken,
        location,
        organization,
        'Shift'
      );
      // console.log(itemArr);
      setData(itemArr);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  };

  return (
    <Card>
      {loading ? (
        <Card.Header>
          <h5 className="mb-0">Loading...</h5>
        </Card.Header>
      ) : (
        <>
          <Card.Body>
            <JobTable data={data} />
          </Card.Body>
        </>
      )}
    </Card>
  );
}

export default JobIndex;
